<template>
  <MTCard class="p-6 mb-6 bg-[var(--mt-soft-bg)]">

    <!-- HEADER -->
    <div class="flex items-start justify-between gap-4 mb-4">
      <div>
        <h2 class="text-xl font-semibold">
          {{ content.title }}
        </h2>
        <p class="text-sm text-[var(--mt-text-muted)]">
          Quick reminder before we practise
        </p>
      </div>

      <!-- Collapse toggle -->
      <button
        class="text-sm text-[var(--mt-primary)] hover:underline"
        @click="collapsed = !collapsed"
      >
        {{ collapsed ? "Show" : "Hide" }}
      </button>
    </div>

    <!-- BODY -->
    <div v-if="!collapsed">

      <!-- VIDEO -->
      <div
        v-if="content.type === 'video'"
        class="mb-4"
      >
        <iframe
          :src="content.source"
          class="w-full aspect-video rounded-xl border"
          allowfullscreen
        />
      </div>

      <!-- IMAGE -->
      <div
        v-else-if="content.type === 'image'"
        class="mb-4 flex justify-center"
      >
        <img
          :src="content.source"
          :alt="content.title"
          class="max-h-64 rounded-xl border"
        />
      </div>

      <!-- KEY POINTS -->
      <div class="mb-4">
        <h3 class="font-semibold mb-2">
          Remember:
        </h3>
        <ul class="list-disc ml-6 space-y-1 text-sm">
          <li v-for="point in content.keyPoints" :key="point">
            {{ point }}
          </li>
        </ul>
      </div>

      <!-- CTA -->
      <div class="flex justify-end">
        <MTButton
          variant="primary"
          size="sm"
          @click="$emit('startPractice')"
        >
          Got it, let’s practise →
        </MTButton>
      </div>

    </div>
  </MTCard>
</template>

<script setup>
import { ref } from "vue";

import MTCard from "@/components/ui/MTCard.vue";
import MTButton from "@/components/ui/MTButton.vue";

defineProps({
  content: {
    type: Object,
    required: true
  }
});

const collapsed = ref(false);
</script>

<style scoped>
/* Optional subtle emphasis */
</style>
